import React from "react";

import Modals from "../popupModal/modal";

const ConfirmDelete = ({ isOpen, onSuccess, closeModal }) => {
  return (
    <Modals
      isOpen={isOpen}
      onRequestClose={() => closeModal}
      title="Delete Note"
      styles={{
        content: {
          minWidth: "552px",
          maxWidth: "552px",
          minHeight: "350px",
          maxHeight: "350px",
        },
      }}
      btnDark={{
        label: "Delete",
        onclick: () => {
          onSuccess();
          closeModal();
        },
      }}
      btnOutline={{
        label: "Cancel",
        onclick: () => {
          closeModal();
        },
      }}
    >
      <React.Fragment>
        <button
          onClick={closeModal}
          className="close modalCloseBtn"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <p className="mx-auto text-center denyAppointmentText">
          Are you sure you want to delete this note?
        </p>
      </React.Fragment>
    </Modals>
  );
};

export default ConfirmDelete;
